import {
  BOOK_LLD_DOWNLOADED,
  BOOK_LLD_SENDING,
  BOOKS_LLD_DOWNLOADED,
  BOOKS_LLD_FAILED,
  BOOKS_LLD_PENDING,
  BOOKS_LLD_RESET,
} from './types';
import BooksApiService from '../../services/api/BooksApiService';
import { handleError } from '../infos/actions';

export const booksLldPendingAction = () => (
  {
    type: BOOKS_LLD_PENDING,
  }
);
export const bookLldSendingAction = () => (
  {
    type: BOOK_LLD_SENDING,
  }
);

export const booksLldFailedAction = (error) => (
  {
    type: BOOKS_LLD_FAILED,
    payload: error,
  }
);

export const booksLldDownloadedAction = (booksLld) => (
  {
    type: BOOKS_LLD_DOWNLOADED,
    payload: booksLld,
  }
);

export const bookLldDownloadedAction = (book) => (
  {
    type: BOOK_LLD_DOWNLOADED,
    payload: book,
  }
);

export const booksLldResetAction = () => (
  {
    type: BOOKS_LLD_RESET,
  }
);

export function getBooksLld(token, role, limit, page, siteLld) {
  return (dispatch) => {
    dispatch(booksLldPendingAction());
    return BooksApiService
      .getBooksLld(token, role, limit, page, siteLld)
      .then(data => {
        dispatch(booksLldDownloadedAction(data));
        return data;
      })
      .catch(error => {
        dispatch(booksLldFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function postBookStartInventory(authUserToken, bookId, file) {
  return (dispatch) => {
    dispatch(bookLldSendingAction());
    return BooksApiService.postBookStartInventory(authUserToken, bookId, file)
      .then(data => {
        dispatch(bookLldDownloadedAction(data));
        return data;
      })
      .catch(error => {
        dispatch(booksLldFailedAction(error));
        dispatch(handleError(error));
      });

  };
}

export function deleteBookStartInventory(authUserToken, bookId) {
  return (dispatch) => {
    dispatch(bookLldSendingAction());
    return BooksApiService.deleteBookStartInventory(authUserToken, bookId)
      .then(data => {
        dispatch(bookLldDownloadedAction(data));
        return data;
      })
      .catch(error => {
        dispatch(booksLldFailedAction(error));
        dispatch(handleError(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/booksLld/actions.js